const SET_VALIDATION_ERROR = 'EstimateView/SET_VALIDATION_ERROR';

export const setValidationError = (error) => ({
  type: SET_VALIDATION_ERROR,
  error
});

export default (state = null, action) => {
  switch (action.type) {
    case SET_VALIDATION_ERROR:
      return action.error;
    default:
      return state;
  }
}
